import type { SerializedError } from '@reduxjs/toolkit';

// ToDo: Will not work with Core-0.42.. Fix on Merge
import type { AssignedTablesType } from '../../../api/fetchers/assignedTables/types';
import type {
  IActivePromo,
  ICashbackData,
  IPrizeDropData,
  IPromoInformation,
  IPromoPointsData,
  ITournamentData,
} from '../../../api/fetchers/promotions/types';

export enum WinningCondition {
  TotalBet = 'TB',
  TotalPoints = 'TP',
  GenericPoints = 'GP',
  Empty = '',
}
export interface TrophyDisplayData {
  minBet: string;
  showTrophyTooltip: boolean;
  isRoundLimitExceed: boolean;
  visibility: 'active' | 'inactive' | 'none';
}

export interface TopTournamentType {
  endDate: number;
  id: string;
  lastGameId: string | null;
  lastWonScore: number | null;
  winStreak: number;
  winningCondition: string;
  showWsBadge: number;
}

export interface PromotionState {
  assignedTables: AssignedTablesType | null;
  cashbacks: ICashbackData[];
  error?: SerializedError;
  isRedEnvelope: boolean;
  loading: boolean;
  prizeDrops: IPrizeDropData[];
  promoPoints: IPromoPointsData | null;
  showTrophyTooltip: boolean;
  topTournament?: TopTournamentType;
  tournaments: ITournamentData[];
  translations?: Record<string, string>;
  wasTrophyTooltipShown: boolean;
  hasRoundLimitTrophyShown: boolean;
  isRoundLimitExceed: boolean;
  activePromos: IActivePromo[];
  winPopup: IPromoInformation | null;
}
